module.exports = __webpack_public_path__ + "assets/img/4-1.89b858df.jpg";